export const BASIS_POINTS_DIVISOR = 10_000n

export function scaleDown(rawAmount: string | number, decimals: number): string {
  const amountStr = typeof rawAmount === "number" ? rawAmount.toString() : rawAmount;
  if (decimals <= 0) return amountStr;

  // We want to insert a decimal point (from right) after `decimals` digits.
  const padding = decimals - amountStr.length + 1;
  // e.g. if we have "1000000" (7 digits) and decimals=6 => we place a decimal after 6 from right.
  // => "1.000000"

  // pad left with zeros if needed
  const padded = padding > 0 ? "0".repeat(padding) + amountStr : amountStr;
  const pointIndex = padded.length - decimals;
  const whole = padded.slice(0, pointIndex);
  const fraction = padded.slice(pointIndex);

  // Trim trailing zeros after decimal to keep it clean
  const fractionTrimmed = fraction.replace(/0+$/, "");
  const finalStr = fractionTrimmed.length > 0 ? `${whole}.${fractionTrimmed}` : whole;

  return finalStr;
}

/**
 * Convert a user-friendly decimal string into the raw integer amount,
 * based on the token's decimals.
 * E.g., scaleUp("1.0", 9) => BigInt(1000000000)
 */
export function scaleUp(displayAmount: string, decimals: number): bigint {
  if (!displayAmount || Number(displayAmount) === 0) {
    return BigInt(0);
  }
  const parts = displayAmount.split(".");
  const whole = parts[0] || "0";
  const fraction = (parts[1] || "").padEnd(decimals, "0").slice(0, decimals);
  // e.g. decimals=9, fraction="1234" => "123400000"

  const fullStr = whole + fraction; // raw integer string
  return BigInt(fullStr);
}


